import { Box, Icon, type Color, type IconName } from "@salestrak/ui";

/**
 * A custom field's type identity as the Duotone Rounded glyph, inside the 24px
 * footprint a settings row's leading rail expects. Every "fields attached to a
 * type" list renders through it, so the field mark reads the same on a Project
 * type, an Account type and a Contact type.
 */
export function FieldTypeGlyph({
  color,
  icon,
}: {
  color: Color;
  icon: IconName;
}) {
  return (
    <Box align="center" height={24} justify="center" width={24}>
      <Icon color={color} name={icon} size="lg" />
    </Box>
  );
}
